import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { Navbar, Nav, NavItem, NavDropdown } from 'react-bootstrap';
import * as Features from '../../../../shared/Features';
import CreateGenericOrderModal from '../../../../features/orders/view/generic/CreateGenericOrderModal';
import { Translate } from '../../../../shared/LanguageService';
import LogoutLink from './LogoutLink';
import ImpersonateCountryForm from '../../ImpersonateCountryForm';
import ImpersonateForm from '../../ImpersonateForm';
import NavItemReplacement from './NavItemReplacement';
import ScandphotosLogoTypeImage from '../../../../assets/images/logo_scandphotos.png';

class ScandphotosNavbar extends React.Component<any, any> {
    navigateTo = (path) => {
        const { history } = this.props;
        history.push(path);
    };

    render() {
        const {
            toggleNavbar,
            expanded,
            systemVersion,
            displayImpersonationForm,
            setDisplayImpersonationForm,
            displayCountryImpersonationForm,
            setDisplayCountryImpersonationForm,
            loginName,
            unImpersonate,
            unImpersonateCountry,
            toggleCreateGenericOrderModal,
            closeCreateGenericModalAndNavigate,
            showCreateGenericModal,
            user
        } = this.props;
        const { isAuthenticated } = user;

        return (
            <Navbar
                className="header-panel banner navbar navbar-default"
                onToggle={toggleNavbar}
                expanded={expanded}
            >
                <div className="container">
                    <Navbar.Header className="navbar-header">
                        <Navbar.Toggle />
                        <a className="brand" onClick={() => this.navigateTo('/')}>
                            <img id="Image_Logo" src={ScandphotosLogoTypeImage} alt="logga" />
                            {Features.hasFeature(
                                Features.ViewSiteVersionNumber,
                                this.props.user
                            ) && (
                                <span id="Label_Version" className="css_version">
                                    {Translate('header/label/version', {
                                        version: systemVersion
                                    })}
                                </span>
                            )}
                        </a>
                    </Navbar.Header>
                </div>
                <Navbar.Collapse>
                    <div className="container-fluid-1" id="main-menu">
                        <Nav className={isAuthenticated || 'unauthorized'}>
                            {isAuthenticated || (
                                <NavItemReplacement
                                    component={
                                        <li className="unauthorized">
                                            <i className="material-icons">lock_outline</i>
                                        </li>
                                    }
                                />
                            )}
                            {isAuthenticated && (
                                <NavItem onSelect={() => this.navigateTo('/')}>
                                    {Translate('header/nav/home')}
                                </NavItem>
                            )}

                            {Features.hasFeature(Features.CreateOrder, this.props.user) && (
                                <NavItem
                                    onSelect={() => this.navigateTo('/scandphotos/orders/new')}
                                >
                                    {Translate('scandphotos/header/nav/new-order')}
                                </NavItem>
                            )}

                            {Features.hasFeature(Features.ListOrders, this.props.user) && (
                                <NavItem onSelect={() => this.navigateTo('/orders')}>
                                    {Translate('header/nav/orders-list')}
                                </NavItem>
                            )}

                            {Features.hasFeature(
                                Features.ViewPhotographerOrders,
                                this.props.user
                            ) && (
                                <NavItem onSelect={() => this.navigateTo('/photographer-uploads')}>
                                    {Translate('header/nav/photographer-uploads')}
                                </NavItem>
                            )}

                            {Features.hasFeature(
                                Features.ViewPhotographerOrders,
                                this.props.user
                            ) && (
                                <NavItem
                                    onSelect={() => this.navigateTo('/orders-list/photographer')}
                                >
                                    {Translate('header/nav/photographers-photo-orders-list')}
                                </NavItem>
                            )}
                            {Features.hasFeature(
                                Features.ViewUneditedOrdersPage,
                                this.props.user
                            ) && (
                                <NavItem onSelect={() => this.navigateTo('/unedited-orders')}>
                                    {Translate('header/nav/unedited-orders')}
                                </NavItem>
                            )}
                            {Features.hasFeature(
                                Features.ViewUneditedFuturePhotoOrderList,
                                this.props.user
                            ) && (
                                <NavItem
                                    onSelect={() => this.navigateTo('/unedited-future-orders')}
                                >
                                    {Translate('header/nav/unedited-future-orders')}
                                </NavItem>
                            )}
                            {Features.hasFeature(
                                Features.PlanEditorOrdersList,
                                this.props.user
                            ) && (
                                <NavItem onSelect={() => this.navigateTo('/orderlist')}>
                                    {Translate('header/nav/orderlist')}
                                </NavItem>
                            )}
                        </Nav>
                        <Nav className="navbar-right">
                            {displayImpersonationForm &&
                                Features.hasFeature(Features.Impersonation, this.props.user) && (
                                    <NavItemReplacement
                                        component={
                                            <li role="presentation">
                                                <ImpersonateForm
                                                    onUserImpersonated={() =>
                                                        setDisplayImpersonationForm(false)
                                                    }
                                                    onClose={() =>
                                                        setDisplayImpersonationForm(false)
                                                    }
                                                />
                                            </li>
                                        }
                                    />
                                )}
                            {displayCountryImpersonationForm &&
                                Features.hasFeature(
                                    Features.ImpersonateCountry,
                                    this.props.user
                                ) && (
                                    <NavItemReplacement
                                        component={
                                            <li role="presentation">
                                                <ImpersonateCountryForm
                                                    onUserCountryImpersonated={() =>
                                                        setDisplayCountryImpersonationForm(false)
                                                    }
                                                    onClose={() =>
                                                        setDisplayCountryImpersonationForm(false)
                                                    }
                                                />
                                            </li>
                                        }
                                    />
                                )}
                            {Features.hasFeature(Features.ViewHelpPortal, user) && (
                                <NavItem
                                    onSelect={() =>
                                        window.open('http://support.se360.se', '_blank')
                                    }
                                >
                                    {Translate('header/nav/help')}
                                </NavItem>
                            )}
                            {isAuthenticated && (
                                <NavDropdown id="profile" title={loginName}>
                                    {!this.props.impersonation &&
                                        !this.props.impersonatedCountry &&
                                        !displayImpersonationForm &&
                                        Features.hasFeature(
                                            Features.Impersonation,
                                            this.props.user
                                        ) && (
                                            <NavItem
                                                onSelect={() => {
                                                    setDisplayImpersonationForm(true);
                                                }}
                                            >
                                                <i className="material-icons">supervisor_account</i>{' '}
                                                {Translate('header/nav/impersonate-customer')}
                                            </NavItem>
                                        )}
                                    {!this.props.impersonation &&
                                        !this.props.impersonatedCountry &&
                                        !displayCountryImpersonationForm &&
                                        Features.hasFeature(
                                            Features.ImpersonateCountry,
                                            this.props.user
                                        ) && (
                                            <NavItem
                                                onSelect={() =>
                                                    setDisplayCountryImpersonationForm(true)
                                                }
                                            >
                                                <i className="material-icons">flag</i>{' '}
                                                {Translate('header/nav/impersonate-country')}
                                            </NavItem>
                                        )}
                                    {!this.props.impersonation && (
                                        <NavItem
                                            onSelect={() => {
                                                this.navigateTo('/profile');
                                            }}
                                        >
                                            <i className="material-icons">person</i>{' '}
                                            {Translate('header/nav/profile')}
                                        </NavItem>
                                    )}
                                    {this.props.impersonation && (
                                        <NavItemReplacement
                                            component={
                                                <li>
                                                    <a
                                                        href="#"
                                                        onClick={unImpersonate}
                                                        title={Translate(
                                                            'header/button-label/leave-impersonation'
                                                        )}
                                                    >
                                                        <i className="material-icons">
                                                            exit_to_app
                                                        </i>{' '}
                                                        {Translate(
                                                            'header/button-label/leave-impersonation'
                                                        )}
                                                    </a>
                                                </li>
                                            }
                                        />
                                    )}
                                    {this.props.impersonatedCountry && (
                                        <NavItemReplacement
                                            component={
                                                <li>
                                                    <a
                                                        href="#"
                                                        onClick={unImpersonateCountry}
                                                        title={Translate(
                                                            'header/button-label/leave-country-impersonation'
                                                        )}
                                                    >
                                                        <i className="material-icons">flag</i>{' '}
                                                        {Translate(
                                                            'header/button-label/leave-country-impersonation'
                                                        )}
                                                    </a>
                                                </li>
                                            }
                                        />
                                    )}
                                    <NavItemReplacement
                                        component={
                                            <li>
                                                <LogoutLink
                                                    logoutText={Translate('header/nav/logout')}
                                                />
                                            </li>
                                        }
                                    />
                                </NavDropdown>
                            )}
                        </Nav>
                    </div>
                    {showCreateGenericModal && (
                        <CreateGenericOrderModal
                            showModal={showCreateGenericModal}
                            closeModal={toggleCreateGenericOrderModal}
                            closeAndNavigate={closeCreateGenericModalAndNavigate}
                        />
                    )}
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default withRouter(ScandphotosNavbar);
